if (!customElements.get('export-cart')) {
    class ExportCart extends HTMLElement {
        connectedCallback() {
            this.exportCartButtons = this.querySelectorAll('.export-cart-button');
            
            this.boundHandleCartExport = this.handleExportClick.bind( this );
            if ( this.exportCartButtons.length > 0 ) {
                console.log( 'running cart export init...' );
                this.cartExportInit( this.exportCartButtons );
            }
        }

        cartExportInit( buttons ) {
            if ( this.hasRefreshQueryParams( [ 'reloadForExport' , 'exportClicked' ] ) ) {
                this.removeRefreshQueryParam( 'reloadForExport' , 'true' );
                this.removeRefreshQueryParam( 'exportClicked' , 'true' );
                this.boundHandleCartExport();
            } else {
                // remove the reload for export since fresh load
                this.removeRefreshQueryParam( 'reloadForExport' , 'true' );
            }
        
            for ( let i = 0; i < buttons.length; i++ ) {
                buttons[i].addEventListener('click' , this.boundHandleCartExport )
            }
        }

        exportCartAsCSV( data ) {
            var csvString = this.objectArrayToCSVFormat( data );
            var blob = new Blob( [ csvString ], { type: "text/csv;charset=utf-8;" } );
            var url = window.URL.createObjectURL( blob );
            var dlnk = document.createElement( 'a' ); 
            const now = new Date();
        
            dlnk.download = `cart-export-${now.getTime()}.csv`;
            dlnk.href = url;
            dlnk.click();
        
            return;
        }

        objectArrayToCSVFormat( data ) {
            let finalRowsString = '';

            const csvRows = [];
            const headerKeys = Object.keys(data[0]);
            const headers = headerKeys.join(',');
            csvRows.push( headers );
            
            for ( let i = 0; i < data.length; i++ ) {
                let values = [];
                for ( let j = 0; j < headerKeys.length; j++ ) {
                    let val = data[i][headerKeys[j]].toString();
                    val = val.replaceAll('"' , '""');	// escape double quotes
                    values.push(`"${val}"`);			// quote it
                }
        
                let valuesAsRow = values.join(',');
                csvRows.push( valuesAsRow );
            }
        
            finalRowsString = csvRows.join('\r\n'); 	// rows starting on new lines
            
            return finalRowsString;
        }

        handleExportClick() {
            // if we click and we triggered the reload for export...
            if ( this.hasRefreshQueryParams( ['reloadForExport'] ) ) {
                // add the flag
                this.addRefreshQueryParam( 'exportClicked' , 'true' );
                // reload
                window.location.reload();
            } else {
                const exportData = this.querySelector('#cart-export-data');
                if ( exportData != null ) {
                    const exportDataString = exportData.innerHTML;
                    const exportDataJSON = JSON.parse( exportDataString );
                    this.exportCartAsCSV( exportDataJSON );
                }
            }

            return;
        }

        addRefreshQueryParam( key , value ) {
            const currentUrl = new URL( window.location.href );
            const urlParams = new URLSearchParams( window.location.search );
            const shouldReload = urlParams.get( key );
            if ( shouldReload == null ) {
                urlParams.append( key , value );
                currentUrl.search = urlParams;
                window.history.replaceState( {}, null, currentUrl.href );
            }
        
            return;
        }

        removeRefreshQueryParam( key , value ) {
            const currentUrl = new URL( window.location.href );
            const urlParams = new URLSearchParams( window.location.search );
            const shouldReload = urlParams.get( key );
            if ( shouldReload != null ) {
                urlParams.delete( key , value );
                currentUrl.search = urlParams;
                window.history.replaceState( {}, null, currentUrl.href );
            }
        }

        hasRefreshQueryParams( keysToFind ) {
            let hasParams = false;
            const urlParams = new URLSearchParams( window.location.search );
        
            let count = 0;
            for ( let key of keysToFind ) {
                const paramValue = urlParams.get( key );
                if ( paramValue != null ) {
                    count = count + 1;
                }
            }
            
            if ( count == keysToFind.length ) {
                hasParams = true;
            }
        
            return hasParams;
        }
    }



    customElements.define( "export-cart", ExportCart );
}